/**
 * NotificationListContainer
 * --
 */
import React from 'react';
import NotificationListPresenter from './NotificationListPresenter';

const NotificationListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <NotificationListPresenter />
    </>
  );
};

export default NotificationListContainer;
